export default process.env.REACT_APP_GOOGLE_MAP_KEY;
